var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m93.94 42.63h-80.16l20.28-20.22h80.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m93.94 105.59h-80.16l20.28-20.21h80.16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34.06 74.11h80.16l-20.28-20.22h-80.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins1);
export default __webpack_public_path__ + "static/media/coins (1).261cfd03f7d09364a2df5739d7d59931.svg";
export { ForwardRef as ReactComponent };